import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';
import { SitemapComponent } from './components/sitemap/sitemap.component';
import { routes } from './sitemap.routes';

@NgModule({
  imports: [CommonModule, UIRouterModule.forChild(routes)],
  declarations: [SitemapComponent],
})
export class SitemapModule {}
